/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import { ApiEvent, ApiEventFromJSON, ApiEventFromJSONTyped, ApiEventToJSON } from './ApiEvent';
import {
  ApiFormFieldCheckbox,
  ApiFormFieldCheckboxFromJSON,
  ApiFormFieldCheckboxFromJSONTyped,
  ApiFormFieldCheckboxToJSON,
} from './ApiFormFieldCheckbox';
import {
  ApiFormFieldCollapsible,
  ApiFormFieldCollapsibleFromJSON,
  ApiFormFieldCollapsibleFromJSONTyped,
  ApiFormFieldCollapsibleToJSON,
} from './ApiFormFieldCollapsible';
import {
  ApiFormFieldConfig,
  ApiFormFieldConfigFromJSON,
  ApiFormFieldConfigFromJSONTyped,
  ApiFormFieldConfigToJSON,
} from './ApiFormFieldConfig';
import {
  ApiFormFieldSelectValue,
  ApiFormFieldSelectValueFromJSON,
  ApiFormFieldSelectValueFromJSONTyped,
  ApiFormFieldSelectValueToJSON,
} from './ApiFormFieldSelectValue';

/**
 *
 * @export
 * @interface ApiPetV2FormField
 */
export interface ApiPetV2FormField {
  /**
   * This is the name of the pet attribute, which matches the PetProfile attribute names defined in the API spec for pet-profile-a/b.
   * @type {string}
   * @memberof ApiPetV2FormField
   */
  name: ApiPetV2FormFieldNameEnum;
  /**
   * The order the FormField should display on the form. Ordering starts from 1 as the highest order.
   * @type {number}
   * @memberof ApiPetV2FormField
   */
  order: number;
  /**
   *
   * @type {string}
   * @memberof ApiPetV2FormField
   */
  type: ApiPetV2FormFieldTypeEnum;
  /**
   * The label that is displayed to the customer to let them know what the field represents
   * @type {string}
   * @memberof ApiPetV2FormField
   */
  label: string;
  /**
   * The placeholder text that is displayed when a value is not set.
   * @type {string}
   * @memberof ApiPetV2FormField
   */
  placeholder: string;
  /**
   * The placeholder text that is displayed to the customer to further describe what they should enter in the field.
   * @type {string}
   * @memberof ApiPetV2FormField
   */
  note?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof ApiPetV2FormField
   */
  isDerived: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiPetV2FormField
   */
  value?: string;
  /**
   *
   * @type {Array<ApiFormFieldSelectValue>}
   * @memberof ApiPetV2FormField
   */
  values?: Array<ApiFormFieldSelectValue>;
  /**
   *
   * @type {ApiFormFieldCheckbox}
   * @memberof ApiPetV2FormField
   */
  checkbox?: ApiFormFieldCheckbox;
  /**
   *
   * @type {ApiFormFieldCollapsible}
   * @memberof ApiPetV2FormField
   */
  collapsible?: ApiFormFieldCollapsible;
  /**
   *
   * @type {ApiFormFieldConfig}
   * @memberof ApiPetV2FormField
   */
  config: ApiFormFieldConfig;
  /**
   *
   * @type {ApiEvent}
   * @memberof ApiPetV2FormField
   */
  event: ApiEvent;
}

/**
 * @export
 */
export const ApiPetV2FormFieldNameEnum = {
  Name: 'name',
  Breeds: 'breeds',
  Birthday: 'birthday',
  AdoptionDate: 'adoptionDate',
  Weight: 'weight',
  GenderAndSterilization: 'genderAndSterilization',
  Medications: 'medications',
  MedicationAllergies: 'medicationAllergies',
  MedicalConditions: 'medicalConditions',
  Type: 'type',
} as const;
export type ApiPetV2FormFieldNameEnum = typeof ApiPetV2FormFieldNameEnum[keyof typeof ApiPetV2FormFieldNameEnum];

/**
 * @export
 */
export const ApiPetV2FormFieldTypeEnum = {
  Text: 'text',
  Number: 'number',
  Date: 'date',
  Select: 'select',
} as const;
export type ApiPetV2FormFieldTypeEnum = typeof ApiPetV2FormFieldTypeEnum[keyof typeof ApiPetV2FormFieldTypeEnum];

export function ApiPetV2FormFieldFromJSON(json: any): ApiPetV2FormField {
  return ApiPetV2FormFieldFromJSONTyped(json, false);
}

export function ApiPetV2FormFieldFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiPetV2FormField {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    name: json['name'],
    order: json['order'],
    type: json['type'],
    label: json['label'],
    placeholder: json['placeholder'],
    note: !exists(json, 'note') ? undefined : json['note'],
    isDerived: json['isDerived'],
    value: !exists(json, 'value') ? undefined : json['value'],
    values: !exists(json, 'values')
      ? undefined
      : (json['values'] as Array<any>).map(ApiFormFieldSelectValueFromJSON),
    checkbox: !exists(json, 'checkbox')
      ? undefined
      : ApiFormFieldCheckboxFromJSON(json['checkbox']),
    collapsible: !exists(json, 'collapsible')
      ? undefined
      : ApiFormFieldCollapsibleFromJSON(json['collapsible']),
    config: ApiFormFieldConfigFromJSON(json['config']),
    event: ApiEventFromJSON(json['event']),
  };
}

export function ApiPetV2FormFieldToJSON(value?: ApiPetV2FormField | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    name: value.name,
    order: value.order,
    type: value.type,
    label: value.label,
    placeholder: value.placeholder,
    note: value.note,
    isDerived: value.isDerived,
    value: value.value,
    values:
      value.values === undefined
        ? undefined
        : (value.values as Array<any>).map(ApiFormFieldSelectValueToJSON),
    checkbox: ApiFormFieldCheckboxToJSON(value.checkbox),
    collapsible: ApiFormFieldCollapsibleToJSON(value.collapsible),
    config: ApiFormFieldConfigToJSON(value.config),
    event: ApiEventToJSON(value.event),
  };
}
